import axiosInstance from '../axiosInstance';
import { getManagerRoutePath } from '../managerRouteUtil';

/**
 * Evacuation plans — zones, floor-plan maps and per-resident evacuation detail.
 *
 * Every write returns the whole refreshed plan (zones + unassigned pool + stats),
 * so callers replace their state from the response instead of refetching.
 */
const evacuationPlanService = {
  getPlan: async () => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.get(`/${routePath}/evacuation-plan`);
    return response.data;
  },

  // `map` is an optional File. Sent as multipart when present so the same
  // endpoint handles both cases.
  createZone: async ({ name, map }) => {
    const routePath = getManagerRoutePath();
    if (!map) {
      const response = await axiosInstance.post(`/${routePath}/evacuation-plan/zones`, { name });
      return response.data;
    }
    const form = new FormData();
    form.append('name', name);
    form.append('map', map);
    const response = await axiosInstance.post(`/${routePath}/evacuation-plan/zones`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Omitting `map` keeps the zone's current map.
  updateZone: async (id, { name, map }) => {
    const routePath = getManagerRoutePath();
    if (!map) {
      const response = await axiosInstance.patch(`/${routePath}/evacuation-plan/zones/${id}`, { name });
      return response.data;
    }
    const form = new FormData();
    if (name !== undefined) form.append('name', name);
    form.append('map', map);
    const response = await axiosInstance.patch(`/${routePath}/evacuation-plan/zones/${id}`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  deleteZone: async (id) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.delete(`/${routePath}/evacuation-plan/zones/${id}`);
    return response.data;
  },

  assignResident: async (zoneId, { residence_id, room }) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.post(
      `/${routePath}/evacuation-plan/zones/${zoneId}/residents`,
      { residence_id, room }
    );
    return response.data;
  },

  // Pass zone_id: null to unassign while keeping the resident's plan detail.
  updateAssignment: async (residenceId, payload) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.patch(
      `/${routePath}/evacuation-plan/residents/${residenceId}`,
      payload
    );
    return response.data;
  },
};

export default evacuationPlanService;
